import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditAssetReady} from '../redux/assets'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'




import {EntityStatus} from '../../../common/DropDowns/index'
//import * as Helpers from '../../../common/helpers'

class AddEditAsset extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,
        selectedPlatforms:[],
        deletedPlatforms:[],
        platformsList:[],
        platformsListData:[],
        availableAllStoreFlag:false,

        assetData:{},

        assetName: "",
        assetGroup: "",
        assetCode: "",
        status: "",

        assetNameErrorText: false,
        assetNameErrorData: '',


        assetCodeErrorText: false,
        assetCodeErrorData: '',

        assetGroupErrorText: false,
        assetGroupErrorData: '',

        statusErrorText: false,
        statusGroupErrorData: '',

        subTitle: Constants.ADD_ASSET

    }

    this.isComponentStillMounted = true

    this.assetNameComponent = null
    this.assetNameSection = null

    this.assetGroupComponent = null
    this.assetGroupSection = null

    this.assetCodeComponent = null
    this.assetCodeSection = null

    this.statusCodeComponent = null
    this.statusCodeSection = null

    }

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditAssetReady(false))

    if (this.props.assets && this.props.assets.assetSelectedId && this.props.assets.assetSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_ASSET))
        this.setState({
            subTitle: "Edit Asset",
            editFlag:true
        })

        this.getAssetById(this.props.assets.assetSelectedId)
    } else {
        this.props.dispatch(headerDataUpdate(Constants.ADD_ASSET))
        this.setState({
            subTitle: "Add Asset"
        })
        this.getPlatformsComboList()
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()
}



    getPlatformsComboList=(platformsList=[])=>{
         apiService.getPlatformsComboList()
                .then(responseData => {
                    this.props.dispatch(addEditAssetReady(true))
                    if(this.isComponentStillMounted && responseData.status === "SUCCESS") {
                         let list = {}
                            list = Object.keys(responseData.data).map((value,index) => {
                                
                                return {
                                    name : responseData.data[value],
                                    platform_id : value,
                                    available : false,
                                    availableAllStoreFlag:false,
                                    storeUpdate:false,
                                }
                            })
                            list.sort((a,b) => a.name.localeCompare(b.name));

                            if(this.state.editFlag){
                                 for(let i=0;i<platformsList.length;i++){
                                    for(let j=0;j<list.length;j++){
                                        if(parseInt(list[j]['platform_id'],10)===platformsList[i]['platform_id']){
                                            list[j]['id']=platformsList[i]['id']
                                            list[j]['available']=true
                                        }
                                    }
                                }
                            }

                           
                            this.setState({
                                platformsListData: list,
                            });
                    }
                })
                .catch(err => {
                    console.log("Error data: ", err)
                    this.props.dispatch(addEditAssetReady(true))
                    this.dialog.show({
                        title: "Server respond with Error data",
                        body: 'Getting store groups got interrupted',
                        actions: [
                            Dialog.OKAction(() => {
                            })
                        ],
                        onHide: (dialog) => {
                            dialog.hide()
                        }
                    })
                })
        
    }

componentDidMount() {

        this.assetNameSection = ReactDOM.findDOMNode(this.refs.assetNameSection)

        this.assetGroupSection = ReactDOM.findDOMNode(this.refs.assetGroupSection)

        this.assetCodeSection = ReactDOM.findDOMNode(this.refs.assetCodeSection)

        this.statusSection = ReactDOM.findDOMNode(this.refs.statusSection)


}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}





onSaveClick = () => {

    this.props.dispatch(addEditAssetReady(false))
    let data = {}

    let assetNameObject = this.mandateValidation("assetName", Constants.FORM_INPUT)
    if (assetNameObject.status) {
        data.name = this.assetNameComponent.value
    } else {

         this.props.dispatch(addEditAssetReady(true))
        return
    }


    let assetCodeObject = this.mandateValidation("assetCode", Constants.FORM_INPUT)
    if (assetCodeObject.status) {
        data.code = this.assetCodeComponent.value
    } else {
        this.props.dispatch(addEditAssetReady(true))
        return
    }

    let assetGroupObject = this.mandateValidation("assetGroup", Constants.FORM_SELECT)
    if (assetGroupObject.status) {
        data.asset_group_id = this.assetGroupComponent.value
    } else {
        this.props.dispatch(addEditAssetReady(true))
        return
    }

    if(this.state.editFlag){
        let statusObject = this.mandateValidation("status", Constants.FORM_SELECT)
        if (statusObject.status) {
            data.status = this.statusComponent.value
        } else {
            this.props.dispatch(addEditAssetReady(true))
            return
        }
    }

    let apiPayloadData=data;


    if(this.state.editFlag){

         apiPayloadData.platforms=[];

    for (var i = 0; i < this.state.platformsListData.length; i++) {
        if(this.state.platformsListData[i]['available'] && (this.state.platformsListData[i]['id']===undefined || this.state.platformsListData[i]['id']==="")) {
            apiPayloadData.platforms.push({"platform_id":this.state.platformsListData[i]['platform_id'],"store_update":this.state.platformsListData[i]['storeUpdate']})
        }else{
            if(!this.state.platformsListData[i]['available'] && this.state.platformsListData[i]['id']!==undefined && this.state.platformsListData[i]['id']!==""){
                apiPayloadData.platforms.push({"id":this.state.platformsListData[i]['id'],"platform_id":this.state.platformsListData[i]['platform_id'],"deleted_flag":true})
            }
        }
    }



        apiService.editAsset(apiPayloadData,this.state.assetData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditAssetReady(true))
                        this.props.history.push("/dashboard/assets/list")
                    } else {

                        this.props.dispatch(addEditAssetReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditAssetReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiPayloadData.platforms=[];

    for (let i = 0; i < this.state.platformsListData.length; i++) {
        if(this.state.platformsListData[i]['available']){
            apiPayloadData.platforms.push({"platform_id":this.state.platformsListData[i]['platform_id'],"store_update":this.state.platformsListData[i]['storeUpdate']})
        }
    }

    apiService.addAsset(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditAssetReady(true))
                        this.props.history.push("/dashboard/assets/list")
                    } else {

                        this.props.dispatch(addEditAssetReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditAssetReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}


getAssetById = (id) => {
    apiService.getAssetById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                        assetData: responseData.data ,
                        assetName : responseData.data.name,
                        assetCode : responseData.data.code,
                        assetGroup : responseData.data.asset_group_id,
                        status : responseData.data.status             
                    })

                    if (this.isComponentStillMounted) {
                        this.assetNameComponent.value=responseData.data.name
                        this.assetCodeComponent.value=responseData.data.code
                        this.assetGroupComponent.value=responseData.data.asset_group_id
                        this.statusComponent.value=responseData.data.status
                    }

                     //this.filterData(responseData.data)
                     let assetPlatforms=responseData.data.asset_platforms ? responseData.data.asset_platforms : []

                     this.getPlatformsComboList(assetPlatforms);
                   // this.props.dispatch(addEditAssetReady(true))             

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditAssetReady(true))
        })
}

checkBoxChange = (platform_id,e) => {

    let platformsListData = this.state.platformsListData;

    let availableAllStoreFlag=false;

    platformsListData.map(function(item, index) {

        if (item['platform_id'] === platform_id) {
            item.available = e.target.checked    

            if(item.id===undefined || item.id===""){
                item.availableToStore=e.target.checked
            }                    
        }

        if(item.available && (item.id===undefined || item.id==="")){
            availableAllStoreFlag=true
        }

        return true
    })

     this.setState({
        platformsListData: platformsListData,
        availableAllStoreFlag:availableAllStoreFlag
    });

}

checkBoxChangeForStore = (platform_id,e) => {

    let platformsListData = this.state.platformsListData;

    platformsListData.map(function(item, index) {
        if (item['platform_id'] === platform_id) {
            item.storeUpdate = e.target.checked
        }
        return true
    })

     this.setState({
        platformsListData: platformsListData
    });

}





 assetGroupChange = (data) => {
    this.assetGroupComponent.value=data.value
        this.setState({
            assetGroup :data.value,
            assetGroupErrorText: false,
            assetGroupErrorData: ''
        })
        this.assetGroupSection.className= this.assetGroupSection.className.replace(" has-error", "")
    }





 entityStatusChange= (data) => {
    
        this.statusComponent.value=data.value
    
        this.setState({
            status :data.value,
            statusErrorText: false,
            statusErrorData: ''
        })
            
        this.statusSection.className= this.statusSection.className.replace(" has-error", "")
    }



    







    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.assetNameSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Name *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Asset Name" type="text" ref={el => this.assetNameComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("assetName")}} />
                                                        <span className="help-block"style={{display: this.state.assetNameErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.assetNameErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                                         <div className="col-md-6 col-sm-12 col-xs-12">
                                                            <div className="form-group" ref={el =>
                                                               this.assetCodeSection = el}>
                                                               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Code *</label>
                                                               <div className="col-sm-9">
                                                                  <input className="form-control" placeholder="Enter Asset Code" type="text" ref={el => this.assetCodeComponent = el}
                                                                  onChange={(e) => {e.preventDefault() 
                                                                  this.keyedInputChange("assetCode")}} />
                                                                  <span className="help-block" style={{ display: this.state.assetCodeErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                                  {this.state.assetCodeErrorData}
                                                                  </span>
                                                               </div>
                                                            </div>
                                                         </div>
                                                    </div>

                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                           
                                            </div>

                                             {(() => {
                                        if(this.state.editFlag){
                                            return (

                                             <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.statusSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Status *</label>
                                                            <div className="col-sm-9" ref={el =>
                                                              this.statusComponent = el}>
                                                              <EntityStatus type="ASSETS" entityStatusChange={this.entityStatusChange} selectedValue={this.state.status} />
                                                              <span className="help-block" style={{ display: this.state.statusErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.statusErrorData}
                                                              </span>
                                                            </div>
                                                        </div>
                                                    </div>                                          
                                                </div>
)
                                        }
                                })()}


                          


                                        
                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>




                                    </div>


                                <div className="box box-info" style={{ borderTop: "0px" }}>
                                    <div className="box-header with-border">

                                     {(() => {
                                        if(this.state.editFlag){
                                            return(
                                                <h3 className="box-title" style={{ fontWeight: 600 }}>Selected Platforms</h3>
                                            )
                                        }else{
                                            return(
                                                <h3 className="box-title" style={{ fontWeight: 600 }}>Select Platforms</h3>
                                            )
                                        }
                                    })()}

                                    </div>
                                    <div className="row" style={{marginTop:"2%"}}>

                                    <div className="col-md-12">
                                    <div className="col-md-6 col-md-offset-1">

                                                <table className="table table-bordered" style={{textAlign:"left"}}>
                                    
                                                        <thead>
                                                            <tr>
                                                            <th style={{width:"30%"}}>Platforms</th>
                                                            <th>Availability</th>

                                                            {(() => {
                                                                if(this.state.availableAllStoreFlag){
                                                                    return(
                                                                                <th>Make available to all stores ? </th>

                                                                            )
                                                                        }
                                                                })()}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                         {this.state.platformsListData.map((item, index) => (

                                                            <tr>
                                                                <td>{this.state.platformsListData[index].name}</td>
                                                                <td><input className="checkbox" type="checkbox" name="checkbox" value="value" style={{"float": "left"}} checked={this.state.platformsListData[index].available} 
                                                                onChange={(e) => {
                                                                    this.checkBoxChange(this.state.platformsListData[index].platform_id,e)
                                                                }}
                                                                /></td>

                                                                 {(() => {
                                                                if(this.state.platformsListData[index].availableToStore){
                                                                    return(

                                                                    <td><input className="checkbox" type="checkbox" name="checkbox" value="value" style={{"float": "left"}} checked={this.state.platformsListData[index].storeUpdate} 
                                                                    onChange={(e) => {
                                                                        this.checkBoxChangeForStore(this.state.platformsListData[index].platform_id,e)
                                                                    }}
                                                                    /></td>
                                                                 )
                                                                        }
                                                                })()}
                                                            
                                                            </tr>
                                                            ))}
                                                        </tbody>
                                                        </table>

                                        

                                    </div>
                                    </div>
                                    </div>

                                </div>



                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        assets: state.assets,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditAsset))


// WEBPACK FOOTER //
// ./src/modules/Assets/Components/AddEditAsset.js